import { useEffect } from 'react'
import { useMatches } from '@tanstack/react-router'
import { formatDocumentTitle, useRecordTitle } from '@/lib/page-title'

/** Keeps document.title on the record's name, else the deepest route's static title. */
export function DocumentTitle() {
  const routeTitle = useMatches({
    select: (matches) =>
      matches.reduce<string | undefined>((title, match) => match.staticData.title ?? title, undefined),
  })
  const recordTitle = useRecordTitle((state) => state.title)
  const title = formatDocumentTitle(recordTitle ?? routeTitle)
  useEffect(() => {
    document.title = title
  }, [title])
  return null
}
